<template>
  <div class="p-4 flex flex-col gap-3 h-full rounded-6xl glass-frosted">
    <div class="flex gap-3">
      <button
        v-for="preset in presets"
        :key="preset.style"
        type="button"
        class="relative w-50 h-35 rounded-lg overflow-hidden cursor-pointer"
        @click="handleSelectPreset(preset.style)"
      >
        <img :src="preset.thumbnail" class="w-full h-full object-cover" draggable="false" />
        <div
          class="absolute inset-0 flex justify-center items-center p-2 transition-all duration-300"
          :class="preset.style === selectedPresetStyle ? 'bg-mask20' : 'hover:bg-mask20'"
        >
          <Icon
            icon="Switch-Fill-Check"
            class="size-18 text-white transition-opacity"
            :class="preset.style === selectedPresetStyle ? 'opacity-100' : 'opacity-0'"
          />
        </div>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { Icon } from '@rapoo/element'
  import type { PresetItem } from '../../utils/types'

  const props = defineProps<{
    presets: PresetItem[]
    activePresetStyle: number | null
    pendingPresetStyle: number | null
  }>()

  const emit = defineEmits<{
    (e: 'select', style: number): void
  }>()

  const selectedPresetStyle = computed(
    () => props.pendingPresetStyle ?? props.activePresetStyle ?? props.presets[0]?.style ?? null,
  )

  const handleSelectPreset = (style: number) => {
    if (style !== props.pendingPresetStyle) {
      emit('select', style)
    }
  }
</script>

<style scoped></style>
